import { TableColumnsType, Tag, Tooltip } from "antd";
import { useState } from "react";
import TableUi from "../../../../../../atoms/Table";
import { ContractMaterialsType } from "../../../../ducks/types";
import EmptyCard from "../../../../../../atoms/EmptyCard";

interface PropsType {
  contractMatData: ContractMaterialsType[] | null | undefined;
}

export default function TabMaterials(props: PropsType) {
  const { contractMatData } = props;
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);

  const columns: TableColumnsType = [
    {
      title: "Material name",
      dataIndex: "name",
      width: 240,
      fixed: "left",
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    // {
    //   title: "Subservices",
    //   dataIndex: "subServices",
    //   width: 240,
    //   render: (text: string[]) =>
    //     text?.length > 0 ? (
    //       <div style={{ display: "flex", gap: "4px" }}>
    //         {text?.slice(0, 1).map((item: string) => {
    //           return (
    //             <Tag key={item} style={{ textTransform: "capitalize" }}>
    //               {item}
    //             </Tag>
    //           );
    //         })}

    //         {text?.length > 1 && (
    //           <Tooltip
    //             title={text
    //               ?.slice(1)
    //               ?.map((item: string) => {
    //                 return item;
    //               })
    //               ?.join(", ")}
    //           >
    //             <Tag
    //               style={{
    //                 background: "#EFF2F3",
    //                 color: "#151718",
    //                 border: "none",
    //                 cursor: "pointer",
    //               }}
    //             >
    //               +{text?.length - 1}
    //             </Tag>
    //           </Tooltip>
    //         )}
    //       </div>
    //     ) : (
    //       "-"
    //     ),
    //   fixed: "left",
    //   sorter: (a, b) => a?.subservices?.localeCompare(b?.subservices),
    // },
    {
      title: "Unit",
      dataIndex: "unit",
      width: 64,
      sorter: (a, b) => a?.unit?.localeCompare(b?.unit),
    },
    {
      title: "Estimated",
      dataIndex: "estimated",
      width: 140,
      render: (text) =>
        text ? Number(text?.toFixed(2))?.toLocaleString() : "-",
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.estimated?.localeCompare(b?.estimated),
    },
    {
      title: "Allocated",
      dataIndex: "allocated",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.allocated?.localeCompare(b?.allocated),
    },
    {
      title: "On order",
      dataIndex: "on_order",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.on_order?.localeCompare(b?.on_order),
    },
    {
      title: "Used to date",
      dataIndex: "used_to_date",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.used_to_date?.localeCompare(b?.used_to_date),
    },
    {
      title: "Purchase orders",
      dataIndex: "purchase_orders",
      width: 200,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.purchase_orders?.localeCompare(b?.purchase_orders),
    },
    {
      title: "Work orders",
      dataIndex: "workOrders",
      width: 240,
      render: (text: string[]) =>
        text?.length > 0 ? (
          <div style={{ display: "flex", gap: "4px" }}>
            {text?.slice(0, 1).map((item: string) => {
              return (
                <Tag key={item} style={{ textTransform: "capitalize" }}>
                  {item}
                </Tag>
              );
            })}

            {text?.length > 1 && (
              <Tooltip
                title={text
                  ?.slice(1)
                  ?.map((item: string) => {
                    return item;
                  })
                  ?.join(", ")}
              >
                <Tag
                  style={{
                    background: "#EFF2F3",
                    color: "#151718",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  +{text?.length - 1}
                </Tag>
              </Tooltip>
            )}
          </div>
        ) : (
          "-"
        ),
      fixed: "left",
      sorter: (a, b) => a?.subservices?.localeCompare(b?.subservices),
    },
  ];

  return (
    <div className="workOrderMaterial">
      {(contractMatData?.length ?? 0) > 0 ? (
        <>
          <h3> Materials </h3>
          <TableUi
            columns={columns}
            data={{
              count: contractMatData?.length || 0,
              data: contractMatData || [],
            }}
            pageSize={limit}
            setPageSize={setLimit}
            setCurrentPage={setPagination}
            currentPage={pagination}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        </>
      ) : (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={282}
            title="There are no materials."
            description=""
            image="/images/empty-icons/no-active.svg"
            // btnText="Create change order"
            // btnLink={`/change-orders/add`}
          />
        </div>
      )}
    </div>
  );
}
